var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9,10.4c-0.2,0.3-0.7,0.4-1,0.2s-0.4-0.6-0.2-0.9c0.6-0.8,0.9-1.7,0.9-2.6c0-0.9-0.3-1.8-0.9-2.6 c-0.2-0.3-0.2-0.7,0.2-0.9c0.3-0.2,0.7-0.1,1,0.2C13.6,4.6,14,5.8,14,7C14,8.2,13.6,9.4,12.9,10.4z M9.2,13.4c0,0.4-0.3,0.6-0.6,0.6 c-0.2,0-0.3-0.1-0.5-0.2L3.9,9.6H0.6C0.3,9.6,0,9.3,0,9V5c0-0.4,0.3-0.6,0.6-0.6h3.3l4.2-4.2c0.3-0.3,0.7-0.3,0.9,0 c0.1,0.1,0.2,0.3,0.2,0.5V13.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcListen);
export default __webpack_public_path__ + "static/media/ic_listen.c1f941589de31a3a1fcc6e009cb67ad5.svg";
export { ForwardRef as ReactComponent };